import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import {
  openCompanySignupModal,
  openInfluencerSignupModal
} from '../../store/actions/signupModalActions';
import { openSignupModal } from '../../store/actions/signupModalActions';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import './Home.css';
import Fab from '@material-ui/core/Fab';
import { Grid } from '@material-ui/core';
import SmsIcon from '@material-ui/icons/Sms';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import Fade from 'react-reveal/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faYoutube,
  faTwitch
} from '@fortawesome/free-brands-svg-icons';

const mapDispatchToProps = dispatch => {
  return {
    openCompanySignupModal: () => dispatch(openCompanySignupModal()),
    openInfluencerSignupModal: () => dispatch(openInfluencerSignupModal()),
    openSignupModal: () => dispatch(openSignupModal())
  };
};

const enhance = compose(
  // Map redux state to props
  connect(
    ({ firebase: { auth, profile } }) => ({
      auth,
      profile
    }),
    mapDispatchToProps
  ),
  // Add props.router (used in handlers)
  withRouter,

  // Add props.firebase (used in handlers)
  withFirebase,

  // Add custom props
  withProps(({ auth, profile }) => ({
    authExists: isLoaded(auth) && !isEmpty(auth),
    auth
  }))
);

class Home extends Component {
  constructor(props, context) {
    super(props, context);

    // this.handleShow = this.handleShow.bind(this);
    // this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      activeLink: 'home',
      influencerSection: 'offer',
      companySection: 'fees'
    };
  }

  componentDidMount() {
    // const script = document.createElement('script');
    // script.src = '//mautic.hypepilot.com/form/generate.js?id=1';
    // var ref = document.querySelector('#newsletter-container');
    // script.async = false;

    // ref.parentNode.insertBefore(script, ref.nextSibling);

    const jqueryScript = document.createElement('script');
    jqueryScript.src = '/js/jquery-3.3.1.min.js';
    var ref1 = document.querySelector('#script-container');
    jqueryScript.async = false;
    ref1.parentNode.insertBefore(jqueryScript, ref1.nextSibling);

    const jqueryMigrateScript = document.createElement('script');
    jqueryMigrateScript.src = '/js/jquery-migrate-3.0.1.min.js';
    var ref2 = document.querySelector('#script-container');
    jqueryMigrateScript.async = false;
    ref2.parentNode.insertBefore(jqueryMigrateScript, ref2.nextSibling);

    const jqueryEasingScript = document.createElement('script');
    jqueryEasingScript.src = '/js/jquery.easing.1.3.js';
    var ref9 = document.querySelector('#script-container');
    jqueryEasingScript.async = false;
    ref9.parentNode.insertBefore(jqueryEasingScript, ref9.nextSibling);

    const aosScript = document.createElement('script');
    aosScript.src = '/js/aos.js';
    var ref10 = document.querySelector('#script-container');
    aosScript.async = false;
    ref10.parentNode.insertBefore(aosScript, ref10.nextSibling);

    const jqStickyScript = document.createElement('script');
    jqStickyScript.src = '/js/jquery.sticky.js';
    var ref12 = document.querySelector('#script-container');
    jqStickyScript.async = false;
    ref12.parentNode.insertBefore(jqStickyScript, ref12.nextSibling);

    const mainScript = document.createElement('script');
    mainScript.src = '/js/main.js';
    var ref13 = document.querySelector('#script-container');
    mainScript.async = false;
    ref13.parentNode.insertBefore(mainScript, ref13.nextSibling);
  }

  changeInfluencerContent = newSection => {
    this.setState({
      influencerSection: newSection
    });
  };

  changeCompanyContent = newSection => {
    this.setState({
      companySection: newSection
    });
  };

  getInfluencerContentImage = () => {
    switch (this.state.influencerSection) {
      case 'offer':
        return 'offer-image';
      case 'money':
        return 'money-image';
      case 'message':
        return 'message-image';
    }
  };

  getInfluencerImageContainer = () => {
    switch (this.state.influencerSection) {
      case 'offer':
        return 'offer-image-container';
      case 'money':
        return 'money-image-container';
      case 'message':
        return 'message-image-container';
    }
  };

  getCompanyContentImage = () => {
    switch (this.state.companySection) {
      case 'fees':
        return 'fees-image';
      case 'analytics':
        return 'analytics-image';
      case 'track':
        return 'track-image';
    }
  };

  getCompanyImageContainer = () => {
    switch (this.state.companySection) {
      case 'fees':
        return 'fees-image-container';
      case 'analytics':
        return 'analytics-image-container';
      case 'track':
        return 'track-image-container';
    }
  };

  setActiveLink = linkName => {
    this.setState({
      activeLink: linkName
    });
  };

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleOpenCompanySignupModal = () => {
    this.props.openCompanySignupModal();
  };

  handleOpenInfluencerSignupModal = () => {
    this.props.openInfluencerSignupModal();
  };

  handleOpenLoginModal = e => {
    e.preventDefault();
    this.props.openSignupModal();
  };

  redirectToLogin = () => {
    this.props.history.push('/signin');
  };

  render() {
    const { activeLink, influencerSection, companySection } = this.state;
    return (
      <React.Fragment>
        <div className="landing-page-background">
          <MetaTags>
            <title>Home</title>
            <meta
              name="description"
              content="We connect top brands with real influencers - a complete and free marketplace for social media influencers. Track and manage your deals with our built-in tracking system, and build trust with those you do business with. Hypepilot enables to hire top-talent influencers on the hottest platforms like YouTube, Instagram, and Twitch."
            />
            <meta
              name="keywords"
              content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
            />
          </MetaTags>
          <div
            id="body-div"
            data-spy="scroll"
            data-target=".site-navbar-target"
            data-offset="300"
          >
            <div className="site-wrap">
              <div className="site-mobile-menu site-navbar-target">
                <div className="site-mobile-menu-header">
                  <div className="site-mobile-menu-close mt-3">
                    <span className="icon-close2 js-menu-toggle"></span>
                  </div>
                </div>
                <div className="site-mobile-menu-body">
                  {/* <ul className="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block"> */}
                  <div onClick={() => this.setActiveLink('home')}>
                    <a
                      href="#home-section"
                      className={`nav-link ${
                        activeLink === 'home' ? 'active-link' : ''
                      }`}
                    >
                      Home
                    </a>
                  </div>
                  <div onClick={() => this.setActiveLink('about')}>
                    <a
                      href="#header-site-section"
                      className={`nav-link ${
                        activeLink === 'about' ? 'active-link' : ''
                      }`}
                    >
                      About
                    </a>
                  </div>
                  <div onClick={() => this.setActiveLink('brands')}>
                    <a
                      href="#brands-section"
                      className={`nav-link ${
                        activeLink === 'brands' ? 'active-link' : ''
                      }`}
                    >
                      Brands
                    </a>
                  </div>
                  <div onClick={() => this.setActiveLink('influencers')}>
                    <a
                      href="#influencers-section"
                      className={`nav-link ${
                        activeLink === 'influencers' ? 'active-link' : ''
                      }`}
                    >
                      Influencers
                    </a>
                  </div>
                  <div onClick={() => this.setActiveLink('login')}>
                    <span
                      // href="#"
                      className={`nav-link ${
                        activeLink === 'login' ? 'active-link' : ''
                      }`}
                      onClick={this.redirectToLogin.bind(this)}
                    >
                      Login
                    </span>
                  </div>
                  <div onClick={() => this.setActiveLink('signup')}>
                    <span
                      className={`btn signup-nav-link ${
                        activeLink === 'contact' ? 'active-link' : ''
                      }`}
                      onClick={this.handleOpenLoginModal}
                    >
                      Signup
                    </span>
                  </div>
                  {/* </ul> */}
                </div>
              </div>

              <header
                className="site-navbar js-sticky-header site-navbar-target"
                role="banner"
              >
                <div className="container-fluid">
                  <div className="d-flex align-items-center">
                    {/* <div className="site-logo"><a href="index.html">Workout<span>.</span> </a></div> */}
                    {/* <img src='/images/text-blue-big.png' className='hp-logo'/> */}
                    <div className="logo-image"></div>
                    <div className="ml-auto">
                      <nav
                        className="site-navigation position-relative text-right"
                        role="navigation"
                      >
                        <ul className="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block">
                          <li onClick={() => this.setActiveLink('home')}>
                            <a
                              href="#home-section"
                              className={` ${
                                activeLink === 'home' ? 'active-link' : ''
                              }`}
                            >
                              Home
                            </a>
                          </li>
                          <li onClick={() => this.setActiveLink('about')}>
                            <a
                              href="#header-site-section"
                              className={` ${
                                activeLink === 'about' ? 'active-link' : ''
                              }`}
                            >
                              About
                            </a>
                          </li>
                          <li onClick={() => this.setActiveLink('brands')}>
                            <a
                              href="#brands-section"
                              className={` ${
                                activeLink === 'brands' ? 'active-link' : ''
                              }`}
                            >
                              Brands
                            </a>
                          </li>
                          <li onClick={() => this.setActiveLink('influencers')}>
                            <a
                              href="#influencers-section"
                              className={` ${
                                activeLink === 'influencers'
                                  ? 'active-link'
                                  : ''
                              }`}
                            >
                              Influencers
                            </a>
                          </li>
                          <li onClick={() => this.setActiveLink('login')}>
                            <a
                              className={`loginStyle ${
                                activeLink === 'login' ? 'active-link' : ''
                              }`}
                              onClick={this.redirectToLogin.bind(this)}
                            >
                              Login
                            </a>
                          </li>
                          <li onClick={() => this.setActiveLink('signup')}>
                            <span
                              className={`btn signup-nav-link ${
                                activeLink === 'contact' ? 'active-link' : ''
                              }`}
                              onClick={this.handleOpenLoginModal}
                            >
                              Signup
                            </span>
                          </li>
                        </ul>
                      </nav>
                      <div className="d-inline-block d-lg-none site-menu-toggle js-menu-toggle float-right">
                        <span className="icon-menu h3"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </header>

              {/* <a id="bgndVideo" className="player"
    // data-image-src="images/hero-1.jpg" data-natural-width={'3000'} data-natural-height={'2000'} data-position-y={'top'}
      data-property="{videoURL:'https://www.youtube.com/watch?v=3P6bEAlW-Vw',showYTLogo:false, showAnnotations: false, showControls: false, cc_load_policy: false, containment:'#home-section',autoPlay:true, mute:true, startAt:255, stopAt: 271, opacity:1}"
      >
    </a> */}

              <div
                className="intro-section"
                id="home-section"
                style={{ backgroundColor: '#ccc' }}
              >
                <div
                  className="heroimg"
                  style={{ backgroundImage: "url('images/hero-1.jpg')" }}
                  data-stellar-background-ratio="0.5"
                >
                  <div className="container">
                    <div className="row align-items-center">
                      <div
                        className="col-lg-12 mx-auto text-center"
                        data-aos="fade-up"
                      >
                        <h1 className="mb-3">
                          Connect with Gaming and eSports Influencers Instantly
                          for Free
                        </h1>
                        <p className="lead mx-auto desc mb-5">
                          An open marketplace for companies and gaming
                          influencers to meet.
                        </p>
                        <span
                          onClick={() => this.handleOpenInfluencerSignupModal()}
                          className="btn btn-outline-white py-3 px-5"
                        >
                          I'm an Influencer
                        </span>
                        <span
                          onClick={() => this.handleOpenCompanySignupModal()}
                          className="btn btn-outline-white py-3 px-5 company-button"
                        >
                          We're a Company
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="header-site-section" id="header-site-section">
                <div className="container">
                  <div className="row justify-content-center text-center mb-5">
                    <div className="col-md-10 section-heading">
                      {/* <span className="subheading">Stay Healthy</span> */}
                      <h2 className="header-heading mb-3">
                        Fast, Free and Gaming Focused
                      </h2>
                      {/* <h2 className="brands-section-title">something about how we're current only supporting youtube</h2> */}
                      <p>
                        Hypepilot lets you buy media and scale influencer
                        campaigns just like you would buy an ad on Instagram or
                        Facebook. Launch your campaign, choose your target
                        audience and get matched with content creators for free.
                      </p>
                    </div>
                  </div>
                  <Grid container className="header-container" direction="row">
                    <Grid item xs={12} sm={4}>
                      <div className="slide">
                        <Fade left>
                          <div className="ftco-feature-1">
                            <FontAwesomeIcon
                              className="icon flaticon-fit"
                              icon={faYoutube}
                            />
                            <div className="ftco-feature-1-text">
                              <h2>YouTube</h2>
                              {/* <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis quo, cumque fuga.</p> */}
                            </div>
                          </div>
                        </Fade>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className="slide">
                        <Fade bottom>
                          <div className="ftco-feature-1">
                            <FontAwesomeIcon
                              className="icon flaticon-fit"
                              icon={faTwitch}
                            />
                            <div className="ftco-feature-1-text">
                              <h2>Twitch</h2>
                              <p className="little-font">(coming soon!)</p>
                            </div>
                          </div>
                        </Fade>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className="slide">
                        <Fade right>
                          <div className="ftco-feature-1">
                            <FontAwesomeIcon
                              className="icon flaticon-fit"
                              icon={faInstagram}
                            />
                            <div className="ftco-feature-1-text">
                              <h2>Instagram</h2>
                              <p className="little-font">(coming soon!)</p>
                            </div>
                          </div>
                        </Fade>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>

              <Fade bottom>
                <img
                  id="brands-section"
                  src="/images/mockup.png"
                  className="mac-outline"
                />
              </Fade>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <p className="green-header padded-top-container">
                    <img
                      className="green-header-icon"
                      src="/images/format-list-checks.png"
                    />
                    <span className="green-header-text">
                      Easily keep track of all your deals
                    </span>
                  </p>
                  <p className="paragraph-header">
                    Built-in deal tracking system
                  </p>
                  <p className="grey-text">
                    Never miss a deal again with our state-of-the industry
                    tracking system. Hypepilot’s deal management interface
                    organizes deals for you, so you can focus on what you do
                    best. You can even request revisions, and receive updates
                    from the other party. And with our built-in messenger
                    system, easy communication is just a single click away.
                  </p>
                  {/* <a onClick={this.handleOpenLoginModal}> */}
                  <p
                    onClick={this.handleOpenLoginModal}
                    className="sign-up-link"
                  >
                    Start Now →
                  </p>
                  {/* </a> */}
                </div>

                <div className="mobile-container white-background">
                  <img
                    className="deal-details-pic-mobile"
                    src="/images/phonefeature.png"
                  />
                </div>
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <p className="green-header padded-top-container">
                    <img
                      className="green-header-icon"
                      src="/images/icons8-compass-26.png"
                    />
                    <span className="green-header-text">
                      Discover the best influencers & brands
                    </span>
                  </p>
                  <p className="paragraph-header">We help your brand grow</p>
                  <p className="grey-text">
                    Find the perfect influencers and companies for you with our
                    search and suggestion system. Know exactly who you’re
                    working with via instant access to their social profiles and
                    reviews of past deals. Hypepilot makes it easy to find the
                    perfect fit for you.
                  </p>
                  {/* <a onClick={this.handleOpenLoginModal}> */}
                  <p
                    onClick={this.handleOpenLoginModal}
                    className="sign-up-link"
                  >
                    Get Started →
                  </p>
                  {/* </a> */}
                </div>
              </div>
              <div className="mobile-container white-background">
                <img
                  className="handshake-pic-mobile"
                  src="/images/handshakefeature.png"
                />
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <img
                    src="/images/numeric-1-circle-outline.png"
                    className="numbered-icon"
                  />
                  <p className="paragraph-header">Track influencers activity</p>
                  <div className="paragraph-text-wrapper grey-text">
                    <p>
                      Conveniently find the statistics which matter most on
                      influencer profiles. Hypepilot allows you to track
                      followers per platform, average views per publication, and
                      much more.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <h2 className="features-text-mobile">Features</h2>
                </div>
              </div>
              <div className="mobile-container white-background">
                <img className="twitch-pic-mobile" src="/images/twitch.png" />
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <img
                    src="images/numeric-2-circle-outline%20(1).png"
                    className="numbered-icon"
                  />
                  <p className="paragraph-header">Build trust</p>
                  <div className="paragraph-text-wrapper grey-text">
                    <p>
                      Our review system for both influencers and companies
                      allows you to both provide, review, and receive
                      multidimensional feedback for those you do business with.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mobile-container white-background">
                <img className="stars-pic-mobile" src="/images/stars.png" />
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <img
                    src="/images/numeric-3-circle-outline.png"
                    className="numbered-icon"
                  />
                  <p className="paragraph-header">
                    Manage Your Campaigns and Offers
                  </p>
                  <div className="paragraph-text-wrapper grey-text">
                    <p>
                      Discover and create campaigns for free. Review offers and
                      even propose revisions. Hypepilot supports payout by
                      products, money, or both. Get paid fast with Instant
                      Payouts for influencers.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mobile-container white-background">
                <img
                  className="feature-3-mobile"
                  src="/images/feature-3-pic.png"
                />
              </div>
              <div className="mobile-container white-background">
                <div className="mobile-wrapper">
                  <img
                    src="/images/numeric-4-circle-outline.png"
                    className="numbered-icon"
                  />
                  <p className="paragraph-header">Inspect your audience</p>
                  <div className="paragraph-text-wrapper grey-text">
                    <p>
                      Detailed analytics provide an overview of audiences which
                      are easily accessible via dashboard widgets. Base your
                      decisions on real-time information constantly updated from
                      supported platforms. Knowledge is power.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mobile-container white-background">
                <img className="feature-3-mobile" src="/images/flags-pic.png" />
              </div>

              {/* ----------------- -------------- */}

              <div className="container-fluid white-background">
                <div className="half-width-container-wrapper">
                  <div className="hwc-r">
                    <div className="half-width-container">
                      <Fade left>
                        <img
                          className="deal-details-pic"
                          src="/images/phonefeature.png"
                        />
                      </Fade>
                    </div>
                    <div className="half-width-container vat left-padded-wrap">
                      <p className="green-header padded-top-container">
                        <img
                          className="green-header-icon"
                          src="/images/format-list-checks.png"
                        />
                        <span className="green-header-text">
                          Easily keep track of all your deals
                        </span>
                      </p>
                      <p className="paragraph-header">
                        Built-in deal tracking system
                      </p>
                      <p className="grey-text">
                        Never miss a deal again with our state-of-the industry
                        tracking system. Hypepilot’s deal management interface
                        organizes deals for you, so you can focus on what you do
                        best. You can even request revisions, and receive
                        updates from the other party. And with our built-in
                        messenger system, easy communication is just a single
                        click away.
                      </p>
                      {/* <a onClick={this.handleOpenLoginModal}> */}
                      <p
                        onClick={this.handleOpenLoginModal}
                        className="sign-up-link"
                      >
                        Start Now →
                      </p>
                      {/* </a> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid white-background">
                <div className="half-width-container-wrapper">
                  <div className="hwc-r">
                    <div className="half-width-container-small vat">
                      <p className="green-header padded-top-container">
                        <img
                          className="green-header-icon"
                          src="/images/icons8-compass-26.png"
                        />
                        <span className="green-header-text">
                          Discover the best influencers & brands
                        </span>
                      </p>
                      <p className="paragraph-header">
                        We help your brand grow
                      </p>
                      <p className="grey-text">
                        Find the perfect influencers and companies for you with
                        our search and suggestion system. Know exactly who
                        you’re working with via instant access to their social
                        profiles and reviews of past deals. Hypepilot makes it
                        easy to find the perfect fit for you.
                      </p>
                      {/* <a onClick={this.handleOpenLoginModal}> */}
                      <p
                        onClick={this.handleOpenLoginModal}
                        className="sign-up-link"
                      >
                        Get Started →
                      </p>
                      {/* </a> */}
                    </div>
                    <div className="half-width-container">
                      <Fade right>
                        <img
                          className="handshake-pic"
                          src="/images/handshakefeature.png"
                        />
                      </Fade>
                    </div>
                  </div>
                </div>
              </div>
              <div id="features" className="container-fluid white-background" />
              <div className="container-fluid white-background">
                <h2 id="influencers-section" className="features-text">
                  Features
                </h2>
                <div className="half-width-container-wrapper">
                  <div className="half-width-container-small vertical-align-middle">
                    <img
                      src="/images/numeric-1-circle-outline.png"
                      className="numbered-icon"
                    />
                    <p className="paragraph-header">
                      Track influencers activity
                    </p>
                    <div className="paragraph-text-wrapper grey-text">
                      <p>
                        Conveniently find the statistics which matter most on
                        influencer profiles. Hypepilot allows you to track
                        followers per platform, average views per publication,
                        and much more.
                      </p>
                    </div>
                  </div>
                  <div className="half-width-container vertical-align-middle">
                    <Fade right>
                      <img className="twitch-pic" src="/images/twitch.png" />
                    </Fade>
                  </div>
                </div>
              </div>
              <div className="container-fluid white-background">
                <div className="half-width-container-wrapper">
                  <div className="half-width-container-small vertical-align-middle">
                    <Fade left>
                      <img
                        className="stars-pic-mobile"
                        src="/images/stars.png"
                      />
                    </Fade>
                  </div>
                  <div className="half-width-container vertical-align-middle">
                    <div className="small-left-pad">
                      <img
                        src="/images/numeric-2-circle-outline%20(1).png"
                        className="numbered-icon"
                      />
                      <p className="paragraph-header">Build trust</p>
                      <div className="paragraph-text-wrapper grey-text">
                        <p id="wide-paragraph">
                          Our review system for both influencers and companies
                          allows you to both provide, review, and receive
                          multidimensional feedback for those you do business
                          with.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid white-background">
                <div className="half-width-container-wrapper">
                  <div className="half-width-container-small-manage vertical-align-middle">
                    <img
                      src="/images/numeric-3-circle-outline.png"
                      className="numbered-icon"
                    />
                    <p className="paragraph-header">
                      Manage Your Campaigns and Offers
                    </p>
                    <div className="paragraph-text-wrapper grey-text">
                      <p>
                        Discover and create campaigns for free. Review offers
                        and even propose revisions. Hypepilot supports payout by
                        products, money, or both. Get paid fast with Instant
                        Payouts for influencers.
                      </p>
                    </div>
                  </div>
                  <div className="half-width-container vertical-align-middle">
                    <Fade right>
                      <img src="/images/feature-3-pic.png" />
                    </Fade>
                  </div>
                </div>
              </div>
              <div className="container-fluid white-background bottom-section">
                <div className="half-width-container-wrapper">
                  <div className="half-width-container-small vertical-align-middle">
                    <Fade left>
                      <img src="/images/flags-pic.png" />
                    </Fade>
                  </div>
                  <div className="half-width-container vertical-align-middle padded-left-column-2">
                    <img
                      src="/images/numeric-4-circle-outline.png"
                      className="numbered-icon"
                    />
                    <p className="paragraph-header">Inspect your audience</p>
                    <div className="paragraph-text-wrapper-2 grey-text">
                      <p>
                        Detailed analytics provide an overview of audiences
                        which are easily accessible via dashboard widgets. Base
                        your decisions on real-time information constantly
                        updated from supported platforms. Knowledge is power!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="site-section contact-wrap" id="contact-section">
                <div className="container">
                  <div className="row justify-content-center text-center">
                    <div className="col-md-8  section-heading">
                      {/* <span className="subheading">Join Hypepilot</span> */}
                      <h2 className="contact-heading mb-3">
                        Influencers - Start Earning Money with Hypepilot Today!
                      </h2>
                      {/* <p className="email-text">team@hypepilot.com</p> */}
                      <span
                        onClick={this.handleOpenLoginModal}
                        className="btn py-3 px-5 influencer-signup-nav-link"
                      >
                        Sign Up Now
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="script-container"></div>
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  authExists: PropTypes.bool,
  router: PropTypes.object
};

export default enhance(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.js